
import { Component, Vue, Prop } from 'vue-property-decorator'
import { appointmentsModule, commonModule, } from '@/store/modules/store-accessor'

@Component
export default class JobShowSignatureModal extends Vue {
    @Prop() payload: Record<string, any>;

    signatureSrc = '';

    async mounted() {
        commonModule.initSnackbar({});
        await this.getSignature();
    }

    async getSignature() {
        const blob = await appointmentsModule.getAppointmentSignature(this.payload.appointmentId);
        this.signatureSrc = URL.createObjectURL(blob);
    }

    async hideModal() {
        commonModule.hideModal();
    }

    doClose() {
        this.hideModal();
    }
}
